<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Booking Status</span><br/>
      <span style="font-style: italic; font-size: 18px">view real-time booking status</span>
    </div>

    <div style="font-size: 24px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      Status Type&nbsp;<b-form-select v-model="status_type" :options="arrivals_or_departures_options" style="font-size: 24px; font-weight: bold; width:170px"/>
      <span v-if="base_options && base_options.length > 2">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;Base&nbsp;<b-form-select v-model="selected_base" :options="base_options" style="font-size: 24px; font-weight: bold; width:170px"/></span>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;Filter&nbsp;<b-form-input style="width: 250px" v-model="booking_filter" placeholder="charterID,vehicle,driver,clientID,status"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;<b-btn size="sm" @click="load_data()"><span style="font-size: 20px; font-weight: bold">Reload</span></b-btn>
    </div>

    <div v-if="!this.$route.query.booking_id && !loading" style="margin: 20px;">
      <div class="row" style="margin: 10px; font-weight: bold; font-size: 24px;">
        <div @click="filter_by_status(null)" class="col" style="border: 1px solid grey;">{{ items.length }} of {{items_full.length}}</div>
        <div @click="filter_by_status('ON TIME')" class="col success" style="border: 1px solid grey;">On Time: {{ontime_cnt}}</div>
        <div @click="filter_by_status('DELAYED')" class="col error" style="border: 1px solid grey;">Delayed: {{delayed_cnt}}</div>
        <div @click="filter_by_status('CANCELLED')" class="col cancelled" style="border: 1px solid grey;">Cancelled: {{cancelled_cnt}}</div>
      </div>
    </div>
    <br/>
    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :tbody-tr-class="get_row_color"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="planned_time" slot-scope="row">
          {{row.item.planned_time | formatDateTimeSmall}}
        </template>

        <template slot="actual_time" slot-scope="row">
          <span v-if="row.item.actual_time">
            {{row.item.actual_time | formatDateTimeSmall}}
          </span>
          <span v-else-if="row.item.estimated_minutes && row.item.estimated_minutes < 10" style="font-weight: bold; color: green">
            {{row.item.estimated_minutes}} minutes away
          </span>
          <span v-else-if="row.item.estimated_minutes" style="font-weight: bold; color: darkred">
            {{row.item.estimated_minutes}} minutes away
          </span>
        </template>

        <template slot="driver" slot-scope="row">
          {{row.item.driver | trim(20)}}
        </template>

        <template slot="status" slot-scope="row">
          <span v-if="row.item.status == 'DELAYED'" style="font-weight: bold; color: darkred">
            {{row.item.status}}
          </span>
          <span v-else style="font-weight: bold; color: green">
            {{row.item.status}}
          </span>
        </template>

        <template slot="routeName" slot-scope="row">
          {{row.item.routeName | trim(30)}}
        </template>

        <template slot="planned_dropoff" slot-scope="row">
          {{row.item.planned_dropoff | formatDateTimeSmall}}
        </template>

      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import {api_url, delete_booking, get_actuals, get_booking_dashboard, save_booking_notes} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment'
import {justDate} from "@/helpers/dates";
import axios from 'axios';

export default {
  name: 'booking_dashboard',
  components: {
  },

  data() {
    return {
      items: [],
      items_full: [],
      selected_status: null,
      status_type: 'departures',
      summary: [],
      loading: true,
      company_options: [],
      base_options: [],
      selected_company: '',
      selected_base: '',
      details_fromDate: justDate(moment()),
      details_toDate: justDate(moment()),
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      actuals_filter: 'finish',
      booking_filter: '',
      booking_search: '',
      arrivals_or_departures_options: [
        { value: 'arrivals', text: 'Arrivals' },
        { value: 'departures', text: 'Departures' },
      ],
      fields: [
        { key: 'charterID', label: 'CharterID', sortable: true},
        { key: 'movementID', label:'MvmtID', sortable: true},
        { key: 'vehicle', label:'Vehicle', sortable: true},
        { key: 'location', label:'Location', sortable: true},
        { key: 'planned_time', label:'Planned', sortable: true},
        { key: 'actual_time', label:'Actual', sortable: true},
        { key: 'status', label: 'Status', sortable: true},
      ]
    }
  },

  async created() {
    this.fields_all = this.fields
    this.check_features()
  },
  methods: {
    async check_features() {
      this.check_cols()
      this.load_data()
    },
    async check_cols() {
      this.fields = this.fields_all
    },
    async load_data() {
      this.loading = true
      try {
        try {
          const {value: {data = []}} = await get_booking_dashboard(this.user.tenant, this.status_type)
          this.summary = data.summary
          moment.tz.setDefault(this.summary.timezone)
          this.items = data.results
          this.items_full = data.results
          this.base_options = data.summary.bases
          this.filter_results()

          if (this.summary.total_cnt != this.items_full.length) {
            this.$emit('showAlert', 'too many results to process for ' + this.booking_search + ', showing partial results', 'warning', 10000)
          }
        } catch(e){
          this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
        }
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    get_time_diff(time1, time2) {
      if (time1 != null && time2 != null)
        return Math.round((new Date(time2) - new Date(time1)) / (1000 * 60)) + 'm';
      return ''
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    get_row_color(item, type) {
      if (!item || type !== 'row') return
      return item.status
    },
    filter_by_status(status) {
      if (status == null || this.selected_status == status) {
        this.selected_status = null
        this.items = this.items_full
      } else {
        this.selected_status = status
        this.items = this.items_full.filter(item => item.status == status)
      }
    },
    filter_results() {
      this.items = this.items_full
      const val = this.booking_filter
      if (val != '')
        this.items = this.items.filter(item => (this.contains(item.bookingID,val) ||
            this.contains(item.status_msg,val) ||
            this.contains(item.driver,val) ||
            this.contains(item.vehicle,val) ||
            this.contains(item.routeName,val) ||
            this.contains(item.bookingBase,val) ||
            this.contains(item.bookingType,val) ||
            this.contains(item.fileHistory,val) ||
            this.contains(item.clientID,val)));

      if (this.selected_base) {
        this.items = this.items.filter(item => this.contains(item.base,this.selected_base))
      }
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    ontime_cnt() {
      return this.items_full.filter(item => item.status == 'ON TIME').length
    },
    delayed_cnt() {
      return this.items_full.filter(item => item.status == 'DELAYED').length
    },
    cancelled_cnt() {
      return this.items_full.filter(item => item.status == 'CANCELLED').length
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    },
    status_type() {
      this.load_data()
    },
    booking_filter() {
      this.filter_results()
    },
    selected_base() {
      this.filter_results()
    }
  }
}
</script>

<style>

.error { background-color: rgba(255,0,0,0.25)}
.success { background-color: hsla(120,100%,75%,0.3)}
.unprocessed { background-color: hsla(200,40%,80%,0.3) }
.cancelled { background-color: hsla(290,60%,70%,0.3) }

.error td { background-color: rgba(255,0,0,0.25)}
.success td {background-color: hsla(120,100%,75%,0.3)}
.unprocessed td { background-color: hsla(200,40%,80%,0.3) }
.cancelled td { background-color: hsla(290,60%,70%,0.3) }


div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

</style>

